<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";

  export let airtable;
  export let fulton_2019;

  var geojson;
  var legend;

  let all_street = [];
  let markers = [];
  let markers_fulton = [];
  let airtablecluster;
  let markersLayer;
  let markersLayer_fulton;

  let customOptions = { className: "airtable-popup" };

  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //

  var mapboxAccessToken =
    "pk.eyJ1IjoiZ3JhY2Vnc3kiLCJhIjoiY2tpN3c3djh1NGxjZTJ4cm16bGdxNHI5ZCJ9.DD9X7XuTcY42PffpEqNo-g";

  onMount(() => {
    airtablecluster = L.map("airtablecluster", {
      minZoom: 9,
      maxZoom: 18,
      preferCanvas: true,
    }).setView([33.82, -84.3], 10);

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 22,
        id: "mapbox/light-v9",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: mapboxAccessToken,
      }
    ).addTo(airtablecluster);

    markersLayer = L.layerGroup(markers);
    markersLayer_fulton = L.layerGroup(markers_fulton);
  });

  $: if (airtable && fulton_2019 && markersLayer && airtablecluster) {

    markersLayer.clearLayers();
    markersLayer_fulton.clearLayers();

    markers = [];

    for (let e of airtable) {
      if (!e.coordinates) {
        continue;
      }

      let circle = L.circleMarker([e.coordinates[0], e.coordinates[1]], {
        radius: 3,
        fillOpacity: 0.8,
        opacity: 0,
        fillColor: "#d1442e",
      }).bindPopup(function () {
        return `<b>ID</b>: ${e.ID}<br/><b>Source</b>: ${e.Source}<br/><b>Property Name</b>: ${e["Property Name"]}<br/><b>Address</b>: ${e.Address}<br/><b>ZIP</b>: ${e.City + " " + e.State + " " + e["Zip Code"]}`
      }, customOptions);
      markers.push(circle);
    }

    markersLayer = L.layerGroup(markers);
    markersLayer.addTo(airtablecluster);

    markers_fulton = [];

    for (let e of fulton_2019) {
      if (!e.X || !e.Y) {
        continue;
      }
      
      let circle = L.circleMarker([e.Y, e.X], {
        radius: 3,
        fillOpacity: 0.2,
        opacity: 0,
        fillColor: "#56a1cc",
      })
      markers_fulton.push(circle);
    }

    markersLayer_fulton = L.layerGroup(markers_fulton);
    markersLayer_fulton.addTo(airtablecluster);
  }

</script>

<div id="airtablecluster" />

<style>
  #airtablecluster {
    height: 70vh;
    width: auto;
    margin: 25px;
  }
</style>
